import { render, staticRenderFns } from "./QuickProcessedMortgagePopUp.vue?vue&type=template&id=2764f5c3&scoped=true&"
import script from "./QuickProcessedMortgagePopUp.vue?vue&type=script&lang=js&"
export * from "./QuickProcessedMortgagePopUp.vue?vue&type=script&lang=js&"
import style0 from "./QuickProcessedMortgagePopUp.vue?vue&type=style&index=0&id=2764f5c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764f5c3",
  null
  
)

export default component.exports